import { render, staticRenderFns } from "./WeightList.vue?vue&type=template&id=6069ec7f&scoped=true&"
import script from "./WeightList.vue?vue&type=script&lang=js&"
export * from "./WeightList.vue?vue&type=script&lang=js&"
import style0 from "./WeightList.vue?vue&type=style&index=0&id=6069ec7f&lang=scss&scoped=true&"
import style1 from "./WeightList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6069ec7f",
  null
  
)

export default component.exports